import SoundSwitcher from "./SoundSwitcher";
import withSoundChange from "./withSoundChange";

export default withSoundChange(SoundSwitcher);
